module.exports = __webpack_public_path__ + "static/img/property_1_jazz_cash.7850e21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/property_1_jazz_cash.png
// module id = zX+C
// module chunks = 1